import React from "react";

import { connect } from "react-redux";

import ZeeTable from "components/ZeeTable";
import ZeeLevelChip from "components/ZeeLevelChip";

import { create, update, remove } from "reducers/stock";
import { setBreadcrumbs } from "reducers/view";

import StockService from "services/stock";

import { getLevels, getRequiredStock, getPendingStock } from "selectors/stock";

class Stock extends React.Component {
  stockService = new StockService();

  constructor() {
    super(...arguments);
    this.props.setBreadcrumbs([{ name: "Stock", slug: "/stock" }]);
  }

  state = {
    isCheckoutVisible: false,
  };
  columns = {
    name: {
      name: "Name",
      // format: (name, row) => {
      //   return (
      //     <span>
      //       {name} {!row.hasSupplier ? <Chip label="No Supplier" /> : null}
      //     </span>
      //   );
      // },
    },
    currentLevel: {
      name: "Stock Level",
      noEdit: true,
      format: (currentLevel, data) => {
        const levels = this.getLevels(data?.id);
        return (
          <ZeeLevelChip
            label={levels.currentLevel}
            color="primary"
            title="Current"
          />
        );
      },
    },
    requiredLevel: {
      name: "Required Stock",
      noEdit: true,
      format: (currentLevel, data) => {
        const levels = this.getLevels(data?.id);
        return (
          <ZeeLevelChip
            label={levels.requiredLevel}
            title="Stock required for order"
          />
        );
      },
    },
    pendingLevel: {
      name: "Pending Stock",
      noEdit: true,
      format: (currentLevel, data) => {
        const levels = this.getLevels(data?.id);
        return (
          <ZeeLevelChip label={levels.pendingLevel} title="Stock in purchase" />
        );
      },
    },
    futureLevel: {
      name: "Future Stock",
      noEdit: true,
      format: (currentLevel, data) => {
        const levels = this.getLevels(data?.id);
        const style =
          levels.futureLevel < 0
            ? {
                background: "red",
                color: "white",
              }
            : {
                background: "lightgreen",
              };

        return (
          <ZeeLevelChip
            label={levels.futureLevel}
            title="Stock after purchases and orders"
            style={style}
          />
        );
      },
    },
  };

  getLevels(stockId) {
    return getLevels(
      this.props.stockLedger,
      this.requiredStock,
      this.pendingStock,
      stockId
    );
  }

  __pendingStock = null;
  get pendingStock() {
    if (!this.__pendingStock) {
      this.__pendingStock = getPendingStock(
        this.props.purchase,
        this.props.purchaseItem
      );
    }
    return this.__pendingStock;
  }

  __requiredStock = null;
  get requiredStock() {
    if (!this.__requiredStock) {
      this.__requiredStock = getRequiredStock(
        this.props.order,
        this.props.orderItem,
        this.props.productStock,
        this.props.productGroup
      );
    }
    return this.__requiredStock;
  }

  async onDelete(stock) {
    const result = await this.stockService
      .delete(stock)
      .then(({ data }) => data);

    if (result.success) {
      this.props.remove(result.data);
      return result.data;
    }
    return false;
  }

  async onEdit(stock) {
    const result = await this.stockService
      .update(stock)
      .then(({ data }) => data);

    if (result.success) {
      this.props.update(result.data);
      return result.data;
    }
    return false;
  }

  async onAdd(stock) {
    const result = await this.stockService
      .create(stock)
      .then(({ data }) => data);

    if (result.success) {
      this.props.create(result.data);
      return result.data;
    }
    return false;
  }

  get supplier() {
    return this.props.supplier;
  }

  get data() {
    return this.props.all.map((item) => {
      const hasSupplier =
        this.props.stockSupplier.filter(
          (stockSupplier) => stockSupplier.stock_id === item.id
        )?.length > 0;

      return { ...item, hasSupplier };
    });
  }

  onRowDoubleClick(stock) {
    const { history } = this.props;
    history.push(`stock/${stock.id}`);
  }

  onSelect(selection) {
    this.setState({
      selection,
    });
  }

  onSelection(selection) {
    const { history } = this.props;
    history.push({ pathname: `purchases/checkout`, state: { selection } });
  }

  onToggleCheckout() {
    this.setState({
      isCheckoutVisible: !this.state.isCheckoutVisible,
    });
  }

  render() {
    return (
      <React.Fragment>
        <ZeeTable
          title="Stock"
          columns={this.columns}
          data={this.data}
          hasMultipleSelection={true}
          confirmText="Purchase"
          hasSelection={true}
          hasPagination={true}
          hasSort={true}
          hasDelete={true}
          hasEdit={true}
          hasAdd={true}
          hasSearch={true}
          orderBy="name"
          onRowDoubleClick={(stock) => this.onRowDoubleClick(stock)}
          onEdit={(stock) => this.onEdit(stock)}
          onDelete={(stock) => this.onDelete(stock)}
          onAdd={(stock) => this.onAdd(stock)}
          onSelect={(selection) => this.onSelect(selection)}
          onSelectionConfirm={(selection) => this.onSelection(selection)}
        />
      </React.Fragment>
    );
  }
}

export default connect(
  (state) => {
    return {
      order: state.order.all,
      orderItem: state.order.item.all,
      product: state.product.all,
      productStock: state.product.stock.all,
      productGroup: state.product.group.all,
      all: state.stock.all,
      stockSupplier: state.stock.supplier.all,
      stockLedger: state.stock.ledger.all,
      supplier: state.supplier.all,
      purchase: state.purchase.all,
      purchaseItem: state.purchase.item.all,
    };
  },
  { update, create, remove, setBreadcrumbs }
)(Stock);
